@if (formFields && editMode) {
  <div>
    <form [formGroup]="myForm">
      @for (field of this.formFields; track field) {
        <div>
          @if (field.type === "text") {
            <div>
              <mat-form-field>
                <label class="font-14 font-grey">{{ field.name }}</label>
                <input
                  matInput
                  [formControlName]="field.key"
                  [name]="field.key"
                />
              </mat-form-field>
            </div>
          }
          @if (field.type === "textarea") {
            <div>
              <mat-form-field>
                <label class="font-14 font-grey">{{ field.name }}</label>
                <textarea
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMaxRows="5"
                  matInput
                  [formControlName]="field.key"
                  [name]="field.key"
                  rows="1"
                ></textarea>
              </mat-form-field>
            </div>
          }
        </div>
      }
      <!-- <div class="open-slow" [ngClass]="{'open-slow-to-height':hasChanged}">
      <button mat-button class="celo-secondary-button" (click)="save()">Save</button>
      <button mat-button class="celo-secondary-button thin-font" (click)="cancel()">Cancel</button>
    </div> -->
      <app-celo-cancel-save-buttons
        [showNow]="hasChanged && !saving"
        (cancelled)="cancel()"
        (save)="save()"
      >
      </app-celo-cancel-save-buttons>
    </form>
  </div>
}
@if (!editMode) {
  <div class="field-data">
    @for (field of this.formFields; track field) {
      <div>
        @if (field.type === "textarea" || field.type === "text") {
          <div>
            <div class="font-14 font-grey">{{ field.name }}</div>
            <div class="font-14">
              {{ field.value ? field.value : "No " + field.name }}
            </div>
          </div>
        }
      </div>
    }
  </div>
}
